import React from "react";
import { AdminWeek } from "./AdminWeek";
import moment from "moment";

export function AdminWeekList(props: { data?: any }) {
  const weeksdata = Array.isArray(props.data?.weeksdata) ? props.data.weeksdata : null;

  if (weeksdata != null) {
    return (
      <>
        <h3>Weekly</h3>
        {weeksdata.map((weekdata: any, index: number) => (
          <AdminWeek
            weekNumber={Number(weekdata.week_number)}
            start={weekdata.start}
            end={weekdata.end}
            weekdata={weekdata}
            key={`${weekdata.start}-${index}`}
          />
        ))}
        {props.data?.show_all ? null : (
          <a href="/admin/?showall=1" className="d-inline-block my-3">
            Show more results...
          </a>
        )}
      </>
    );
  }

  let current_week_start = moment().startOf("isoWeek");
  let weeks = [current_week_start];
  for (let i = 0; i < 5; i++) {
    // Subtract 6 days to get into previous week, but don't overrun in DST changes?
    current_week_start = current_week_start.clone().subtract(6, "d").startOf("isoWeek");
    weeks.push(current_week_start);
  }
  return (
    <>
      <h3>Weekly</h3>
      {weeks.map((week_start) => (
        <AdminWeek
          weekNumber={week_start.isoWeek()}
          start={week_start.startOf("isoWeek").toDate()}
          end={week_start.endOf("isoWeek").toDate()}
          weekdata={undefined}
          key={week_start.toISOString()}
        />
      ))}
    </>
  );
}
